import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { products } from '../../data/products';
import { useCart } from '../../context/CartContext';
import './ProductDetail.css';

const renderStars = (rating) => {
  const full = Math.floor(rating);
  const half = rating % 1 >= 0.5;
  return '★'.repeat(full) + (half ? '½' : '') + '☆'.repeat(5 - full - (half ? 1 : 0));
};

const formatPrice = (price) => '৳' + price.toLocaleString('en-BD');

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart, totalItems } = useCart();
  const [added, setAdded] = useState(false);
  const product = products.find((p) => p.id === parseInt(id, 10));

  if (!product) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <p>Product not found.</p>
        <button onClick={() => navigate('/')}>Go back</button>
      </div>
    );
  }

  const discountedPrice = product.discount
    ? Math.round(product.price * (1 - product.discount / 100))
    : product.price;

  const savings = product.discount ? product.price - discountedPrice : 0;

  const handleTryOn = () => {
    navigate('/try-on', { state: { imageUrl: product.image } });
  };

  const handleAddToCart = () => {
    addToCart(product);
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  };

  return (
    <div className="pd-page">
      <header className="pd-header">
        <button className="pd-back-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <span className="pd-header-title">{product.category}</span>
        <button className="pd-cart-btn" onClick={() => navigate('/cart')}>
          🛒 {totalItems > 0 && <span className="pd-cart-badge">{totalItems}</span>}
        </button>
      </header>

      <div className="pd-content">
        {/* Image */}
        <div className="pd-image-panel">
          <div className="pd-image-wrap">
            <img src={product.image} alt={product.name} className="pd-image" />
          </div>
        </div>

        {/* Details */}
        <div className="pd-details">
          <div className="pd-breadcrumb">
            Home / <span>{product.category}</span>
          </div>

          <div className="pd-brand">{product.brand}</div>
          <h1 className="pd-name">{product.name}</h1>

          <div className="pd-rating-row">
            <span className="pd-stars">{renderStars(product.rating)}</span>
            <span className="pd-rating-val">{product.rating}</span>
            <span className="pd-rating-count">(128 reviews)</span>
          </div>

          <div className="pd-pricing">
            <div>
              <span className="pd-price-main">{formatPrice(discountedPrice)}</span>
              {product.discount && (
                <span className="pd-price-original">{formatPrice(product.price)}</span>
              )}
            </div>
            {product.discount && (
              <>
                <div className="pd-discount-tag">{product.discount}% OFF</div>
                <div className="pd-savings">You save {formatPrice(savings)}</div>
              </>
            )}
          </div>

          <div className="pd-divider" />

          <div className="pd-desc-title">About this item</div>
          <p className="pd-desc">{product.description}</p>

          <div className="pd-tags">
            <span className="pd-tag">{product.category}</span>
            <span className="pd-tag">{product.brand}</span>
            <span className="pd-tag">Premium Quality</span>
            <span className="pd-tag">Fast Delivery</span>
          </div>

          <div className="pd-actions">
            <button className="pd-btn-cart" onClick={handleAddToCart}>
              {added ? '✓ Added to Cart!' : 'Add to Cart'}
            </button>
            <button className="pd-btn-buynow" onClick={() => { addToCart(product); navigate('/checkout'); }}>
              Buy Now
            </button>
            <button className="pd-btn-try" onClick={handleTryOn}>
              <span className="pd-btn-try-icon">✦</span>
              AR Try On
            </button>
            <p className="pd-try-note">Powered by Snap Camera Kit AR</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
